import { render, staticRenderFns } from "./FloatingChat.vue?vue&type=template&id=7250f71d&scoped=true"
import script from "./FloatingChat.vue?vue&type=script&lang=js"
export * from "./FloatingChat.vue?vue&type=script&lang=js"
import style0 from "./FloatingChat.vue?vue&type=style&index=0&id=7250f71d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7250f71d",
  null
  
)

export default component.exports